export const API_CONFIG = {
    BASE_URL: process.env.REACT_APP_API_URL ?? (() => { throw new Error('REACT_APP_API_URL environment variable is required'); })(),
    ENDPOINTS: {
        REGISTER: '/auth/register',
        ADMIN_LOGIN: '/auth/login',
        LOGIN_WITH_TOKEN: '/auth/login-with-token',
        GET_USERS: '/admin/users',
        GET_USER_BY_ID: '/admin/users',
        UPDATE_USER_STATUS: '/admin/users',
        REFRESH_TOKEN: '/auth/refresh',
        LOGOUT: '/auth/logout',
        GET_PLANS: '/stripe/plans',
        CREATE_ONE_TIME_PAYMENT: '/stripe/payment/one-time',
        GET_USER_CLUBS: '/clubs',
        CREATE_CLUB: '/clubs',
        GET_CHALLENGES: '/challenges',
        CREATE_CHALLENGE: '/challenges',
        UPDATE_CHALLENGE: '/challenges',
        DELETE_CHALLENGE: '/challenges',
        INVITE_TO_CLUB: '/invitations/club',
        FORGOT_PASSWORD: '/auth/forgot-password',
        VERIFY_RESET_CODE: '/auth/verify-reset-code',
        RESET_PASSWORD: '/auth/reset-password',
    },
    TIMEOUT: 10000
};

/**
 * Get the avatar URL for a user
 * Uses the backend streaming endpoint
 */
export const getAvatarUrl = (userId: string): string => {
    return `${API_CONFIG.BASE_URL}/users/avatar/${userId}/image`;
};